export const STATES = [
  { value: "AK", label: "Alaska" },
  { value: "TX", label: "Texas" },
  { value: "AL", label: "Alabama" },
  { value: "AR", label: "Arkansas" },
  { value: "AZ", label: "Arizona" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DC", label: "District of Columbia" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "IA", label: "Iowa" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "MA", label: "Massachusetts" },
  { value: "MD", label: "Maryland" },
  { value: "ME", label: "Maine" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MO", label: "Missouri" },
  { value: "MS", label: "Mississippi" },
  { value: "MT", label: "Montana" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "NE", label: "Nebraska" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NV", label: "Nevada" },
  { value: "NY", label: "New York" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VA", label: "Virginia" },
  { value: "VT", label: "Vermont" },
  { value: "WA", label: "Washington" },
  { value: "WI", label: "Wisconsin" },
  { value: "WV", label: "West Virginia" },
  { value: "WY", label: "Wyoming" },
]

export const statesKeyValue = {
  "alaska": "AK",
  "texas": "TX",
  "alabama": "AL",
  "arkansas": "AR",
  "arizona": "AZ",
  "california": "CA",
  "colorado": "CO",
  "connecticut": "CT",
  "columbia": "DC",
  "delaware": "DE",
  "florida": "FL",
  "georgia": "GA",
  "hawaii": "HI",
  "iowa": "IA",
  "idaho": "ID",
  "illinois": "IL",
  "indiana": "IN",
  "kansas": "KS",
  "kentucky": "KY",
  "louisiana": "LA",
  "massachusetts": "MA",
  "maryland": "MD",
  "maine": "ME",
  "michigan": "MI",
  "minnesota": "MN",
  "missouri": "MO",
  "mississippi": "MS",
  "montana": "MT",
  "north Carolina": "NC",
  "north Dakota": "ND",
  "nebraska": "NE",
  "new hampshire": "NH",
  "new jersey": "NJ",
  "new mexico": "NM",
  "nevada": "NV",
  "new york": "NY",
  "ohio": "OH",
  "oklahoma": "OK",
  "oregon": "OR",
  "pennsylvania": "PA",
  "rhode Island": "RI",
  "south Carolina": "SC",
  "south Dakota": "SD",
  "tennessee": "TN",
  "utah": "UT",
  "virginia": "VA",
  "vermont": "VT",
  "washington": "WA",
  "wisconsin": "WI",
  "west Virginia": "WV",
  "wyoming": "WY"
}